import { cloneElement } from 'react'
import PropTypes from 'prop-types'
import {
  Navigate,
} from 'react-router-dom'
import { useSelector } from 'react-redux'
import makeHasPermission from './selectors/makeHasPermission'
import isAuthenticated from './selectors/isAuthenticated'
import getAccessToken from './selectors/getAccessToken'
import getAuthenticationError from './selectors/getAuthenticationError'
import ErrorScreen from './ErrorScreen'

function PrivateScreen({
  permissions,
  permissionsWithRegex,
  screen: Screen,
}) {
  const hasPermission = makeHasPermission()

  const isUserAuthenticated = useSelector(isAuthenticated)
  const hasAccessToken = useSelector(getAccessToken)
  const isPermitted = useSelector((state) => hasPermission(state, {
    permissions,
    permissionsWithRegex,
  }))
  const authenticationError = useSelector(getAuthenticationError)

  if (!isUserAuthenticated) {
    return (
      <Navigate
        to="/sign-in"
      />
    )
  }

  if (authenticationError) {
    return <ErrorScreen authenticationError={authenticationError} />
  }

  if (!hasAccessToken) {
    return cloneElement(Screen, { loadingAccessToken: true })
  }

  if (!isPermitted) {
    return <ErrorScreen permissionError />
  }

  return Screen
}

PrivateScreen.propTypes = {
  screen: PropTypes.element.isRequired,
  permissions: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string.isRequired),
    PropTypes.string,
  ]),
  permissionsWithRegex: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string.isRequired),
    PropTypes.string,
    PropTypes.object,
  ]),
}

PrivateScreen.defaultProps = {
  permissions: null,
  permissionsWithRegex: null,
}

export default PrivateScreen
